import { IDs } from '../../../helpers/IDs';
import { getAssistentConfigEigeneRaeumlichkeiten } from '../assistent/items/assistent_config_eigene_raeumlichkeiten';
import { getAssistentConfigAngemieteteRaeumlichkeiten } from '../assistent/items/assistent_config_angemietete_raeumlichkeiten';
import { getAssistentConfigAngemieteteFahrzeuge } from '../assistent/items/assistent_config_angemietete_fahrzeuge';
import { isEnableCO2, isEnableGHG, isEnableSachanlagen } from '../assistent/assistent_helpers';

export function getSachanlagenStructure() {
    return [
        {
            subscope: 1, category: 'sachanlagen', key: 'angemietete_raeumlichkeiten', name: '2.4.1 Angemietete Räumlichkeiten',
            getItemAssistentConfig: getAssistentConfigAngemieteteRaeumlichkeiten
        },
        {
            subscope: 3, category: 'sachanlagen', key: 'eigene_raeumlichkeiten', name: '2.4.2 Eigene Räumlichkeiten',
            getItemAssistentConfig: getAssistentConfigEigeneRaeumlichkeiten
        },
        {
            subscope: 2, category: 'sachanlagen', key: 'angemietete_fahrzeuge', name: '2.4.3 Angemietete Fahrzeuge',
            getItemAssistentConfig: getAssistentConfigAngemieteteFahrzeuge
        }
    ];
}

export function getSelectableEnergiedatenEntities() {
    return ['angemietete_raeumlichkeiten', 'angemietete_fahrzeuge', 'eigene_raeumlichkeiten'];
}

export function getEnergiedatenAuswahl(data: any, standortTid: number, jahr?: number, jahrVon?: number, jahrBis?: number) {
    const auswahl = (data[IDs.ENT_ENERGIEDATEN_AUSWAHL] || [])
        .filter((r: any) =>
            r.standort_tid_orig === standortTid
            && (jahr > 0 ? r.jahr === jahr : true)
            && (jahrVon > 0 && jahrBis > 0 ? r.jahr >= jahrVon && r.jahr <= jahrBis : true)
            && r.auswahl === 1
        )
        .map((r: any) => r.name)
        .filter((key: string, idx: number, self: Array<string>) => self.indexOf(key) === idx)
        .sort();
    // console.log(jahr, jahrVon, jahrBis, auswahl);
    return filterEnergiedatenAuswahl(auswahl, data);
}

export function filterEnergiedatenAuswahl(auswahl: Array<string>, data: any) {
    const konfiguration: Array<any> = data[IDs.ENT_KONFIGURATION] || [];
    const enableCO2: boolean = isEnableCO2(konfiguration);
    const enableSachanlagen: boolean = isEnableSachanlagen(konfiguration);
    const enableGHG: boolean = isEnableGHG(konfiguration);
    if (!(/*enableCO2 && */enableSachanlagen && enableGHG)) {
        const sachanlagenKeys = getSachanlagenStructure().map((st: any) => st.key);
        return auswahl.filter((k: string) => sachanlagenKeys.indexOf(k) === -1);
    }
    return auswahl;
}